// @flow

import { getGateway } from '@tectonics/prs/gateway';
import type { PendingIncomingPayment } from './types';
import { getWeekDay } from '@tectonics/prs/week-day';
import { formatDueDate } from '@tectonics/prs/voucher';
import { translate } from '@tectonics/translate';

export function getSafeExpirationDatetime(incomingPayment: PendingIncomingPayment): string | null {
  const gateway = getGateway(incomingPayment);
  return gateway['pix_expiration_datetime'];
}

export function getSafeExpirationDatetimeDebin(incomingPayment: PendingIncomingPayment): string {
  const expirationDatetime = incomingPayment['expire_date'];

  if(!expirationDatetime){
    throw new Error('Banktransfer: no expiration date and time in incoming payment');
  }

  return expirationDatetime;
}

export function getExpirationDetailsFromPayment(payment: PendingIncomingPayment): {weekDay:string, formattedDate:string, expireDate:string, expireTime:string} {
  const expirationDateTime = getSafeExpirationDatetimeDebin(payment);
  const dueDateWeekDay = ['lunes', 'martes', 'miércules', 'jueves', 'viernes', 'sábado', 'domingo'];
  const weekDay = getWeekDay(expirationDateTime.substring(0, 10), dueDateWeekDay);
  const expireDate = formatDueDate(expirationDateTime);
  const formattedDate = formatDateToSpanish(expireDate);
  const expireTime = expirationDateTime.substring(11, 16);

  return { weekDay, formattedDate, expireDate, expireTime };
}

export function getExpireDateMessageFromPayment(payment: PendingIncomingPayment): string {
  const { weekDay, formattedDate, expireDate, expireTime } = getExpirationDetailsFromPayment(payment);

  return translate('volcanes.payment-methods.banktransfer.debin.instructionTextExpiryTime', {
    weekDay:       weekDay,
    formattedDate: formattedDate,
    expireDate:    expireDate,
    expireTime:    expireTime,
  });
}

export function formatDateToSpanish(dateString: string): string {
  const [day, month] = dateString.split('/').map(Number);
  const monthsInSpanish = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  return `${day} de ${monthsInSpanish[month - 1]}`;
}
